/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "./ColorsProvider";
import prefixStyles from "./utils/prefixStyles";
import ScreenReaderOnlyLiveRegion from "./ScreenReaderOnlyLiveRegion";

type Props = {
  error?: ?string,
  children: React.Node,
  colors: ColorSet,
};

export const FORM_ERROR_ANIMATION_DELAY = 100;

class FormError extends React.Component<Props> {
  render() {
    const { error, colors } = this.props;

    const styles = prefixStyles({
      errorWrapper: {
        // transition errors so that iOS cursors don't get off center
        // https://bugs.webkit.org/show_bug.cgi?id=138201
        transition: `max-height ${FORM_ERROR_ANIMATION_DELAY}ms`,
        overflow: "hidden",
      },
      error: {
        maxHeight: "5em",
      },
      noError: {
        maxHeight: "0em",
      },
      formError: {
        margin: 0,
        padding: "0.625em",
        fontSize: "0.8em",
        color: colors.RED,
      },
    });

    return (
      <React.Fragment>
        {error ? (
          <ScreenReaderOnlyLiveRegion>
            Error: {error}
          </ScreenReaderOnlyLiveRegion>
        ) : null}
        <div
          style={{
            ...styles.errorWrapper,
            ...(error ? styles.error : styles.noError),
          }}
          data-component-section="error"
        >
          <p style={styles.formError}>{error || " "}</p>
        </div>
        <div style={{ border: error ? `1px solid ${colors.RED}` : "none" }}>
          {this.props.children}
        </div>
      </React.Fragment>
    );
  }
}

export default withColorsProvider(FormError);



// WEBPACK FOOTER //
// ../nx-components/src/FormError.jsx